import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';

const Star = ({ fill }) => {
  return (
    <div className="relative h-6 w-6">
      <StarIcon className="absolute inset-0 text-gray-300" />
      <StarIcon
        className="absolute inset-0 text-bsrate" // Use text-bsrate class for filled part
        style={{ clipPath: `inset(0 ${100 - fill}% 0 0)` }}
      />
    </div>
  );
};

export default Star;
